import type { ReactNode } from 'react';

/** Cabecalho dos paineis do resumo: icone + titulo Cinzel + subtitulo + acao opcional. */
export function PanelTitle({ icon, title, subtitle, action }: { icon: string; title: string; subtitle: string; action?: ReactNode }) {
  return (
    <div className="panel-title-row">
      <div>
        <span className="panel-title-icon">{icon}</span>
        <div><h2>{title}</h2><p>{subtitle}</p></div>
      </div>
      {action}
    </div>
  );
}
